/**
 * ¿A qué tipo de profesional le habla la landing?
 *
 * Los correos de la captación llegan con `utm_campaign=captacion_<segmento>`
 * (coach, box, centro, salud, canarias), y un box no se reconoce en «software
 * para entrenadores personales». Con esto el hero y la sección «Para quién» le
 * hablan a quien ha llegado. También vale `?para=box` para enlazarlo a mano.
 */
export const SEGMENTOS = {
  coach: { badge: "Software gratis para entrenadores personales y coaches online" },
  box: { badge: "Software gratis para boxes de CrossFit y entrenamiento funcional" },
  centro: { badge: "Software gratis para centros y estudios de entrenamiento" },
  salud: { badge: "Software gratis para nutricionistas y fisioterapeutas" },
};

const ALIAS = { canarias: "centro" };

export function segmentoCoach() {
  try {
    const params = new URLSearchParams(window.location.search);
    let s = params.get("para") || "";
    const campana = params.get("utm_campaign") || "";
    if (!s && campana.startsWith("captacion_")) s = campana.slice("captacion_".length);
    s = ALIAS[s] || s;
    return SEGMENTOS[s] ? s : null;
  } catch {
    return null;
  }
}
